import Axios from "@/utils/Axios";
import Axios2 from "@/utils/Axios2";
import qs from "qs";
import Bus from "utils/bus.js";

/**
 * 获取设备列表
 */
export function getEquipmentList(context) {
  let param = {};
  param.method = "post";
  param.url = "/monitor/getMonitorSiteInfo";
  param.data = qs.stringify({
    monitorSiteId: context.saveid
  });
  return Axios.ajax(param).then((res) => {
    if (res.data) {
      context.equipmentData = res.data;
      if (context.equipmentData.terminalTypeName === 'YH-SMART1000S') {
        context.isthree = '3';
      } else {
        if (context.equipmentData.terminalTypeName === 'YH-SMART1000L') {
          context.isb = true;
        }
        if (res.data.terminalPhase === '3') {
          context.isthree = '1';
        } else {
          context.isthree = '2';
        }
      }
      context.savebranchId = context.equipmentData.branchId;
      context.getSaveData();
      context.getEquipStartup();
      context.getDeviceType();
      context.getMisReport();
      context.getMisReportType();
    }
  });
}

/**
 * 获取 cavdata
 */
export function getcavdata(context, riskName) {
  let param = {};
  param.method = "post";
  let keybord = '';
  let type = '';
  for (let i = 0; i < context.riskAll.length; i++) {
    if (context.riskAll[i].riskName === riskName) {
      keybord = i;
    }
  }
  param.data = qs.stringify({
    "monitorSiteId": sessionStorage.getItem("saveid"),
    "params": context.riskAll[keybord].headers,
    "searchDate": context.edtm
  });
  if (context.riskAll[keybord].dataType === '1') {
    param.url = "/analogData/hourFreezeDataInfoV2";
    type = 'bar';
  } else {
    param.url = "/analogData/instantParamDataV2";
    type = 'line';
  }
  return Axios.ajax(param).then((res) => {
    let levlist = [];
    context.cavdata = [];
    if (res.data) {
      if (res.data.checkSafeDatas) {
        context.cavtitle = res.data.freezeDatas[0];
        for (let i = 1; i < res.data.freezeDatas.length; i++) {
          context.cavdata.push(res.data.freezeDatas[i]);
          levlist.push(res.data.checkSafeDatas[i]);
        }
        context.drewcav(context.cavtitle, context.cavdata, levlist, type);
      } else {
        context.cavtitle = res.data[0];
        for (let i = 1; i < res.data.length; i++) {
          context.cavdata.push(res.data[i]);
        }
        context.drewcav(context.cavtitle, context.cavdata, '', type);
      }
    }
  });
}

/**
 * 跳转到数据详情
 */
export function todatadetail(context) {
  Bus.$emit('pushrouter2', [context.equipmentData.siteName + '数据', context.equipmentData.branchId, context.saveid, "/console/sites/detail/data"]);
}

/**
 * 更改保存
 */
export function changesave(context, data) {
  context.issave = data;
}

/**
 * 更改风险
 */
export function changerisk(context, data) {
  context.isrisk = data;
}

/**
 * 获取实时数据
 */
export function getnow(context) {
  let param = {};
  param.method = "post";
  param.url = "/msg/query/realtime/";
  param.data = {
    address: context.equipmentData.addr485,
    topic: context.equipmentData.hostTerminalImei,
  };
  return Axios2.ajax(param).then((res) => {
    if (res.status === '200') {
      context.$message({
        type: 'success',
        message: '请求成功'
      });
    } else {
      context.$message({
        type: 'error',
        message: res.msg
      });
    }
  });
}

/**
 * 获取新数据
 */
export function getnewdata(context) {
  context.isload = true;
  context.getnow();
  context.setsavedata = setInterval(function () {
    context.getSaveData();
  }, 3000);
}

/**
 * 获取当前时间
 */
export function getnowtime(context) {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth(); //得到月份
  var date = now.getDate(); //得到日期

  var hour = now.getHours(); //得到小时
  var minu = now.getMinutes(); //得到分钟
  var sec = now.getSeconds(); //得到秒
  var MS = now.getMilliseconds(); //获取毫秒
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (date < 10) date = "0" + date;
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  if (MS < 100) MS = "0" + MS;

  var time = "";
  time =
    year + "-" + month + "-" + date;
  // 24小时前的时间
  var yesnow = new Date();
  yesnow.setTime(yesnow.getTime() - 24 * 60 * 60 * 1000);
  var yesyear = yesnow.getFullYear(); //得到年份
  var yesmonth = yesnow.getMonth(); //得到月份
  var yesdate = yesnow.getDate(); //得到日期

  var yeshour = yesnow.getHours(); //得到小时
  var yesminu = yesnow.getMinutes(); //得到分钟
  var yessec = yesnow.getSeconds(); //得到秒
  var yesMS = yesnow.getMilliseconds(); //获取毫秒
  yesmonth = yesmonth + 1;
  if (yesmonth < 10) yesmonth = "0" + yesmonth;
  if (yesdate < 10) yesdate = "0" + yesdate;
  if (yeshour < 10) yeshour = "0" + yeshour;
  if (yesminu < 10) yesminu = "0" + yesminu;
  if (yessec < 10) yessec = "0" + yessec;
  if (yesMS < 100) yesMS = "0" + yesMS;
  // 获取当前日期和时间
  var currentDateTime =
    year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
  var yestime = "";
  yestime =
    yesyear +
    "-" +
    yesmonth +
    "-" +
    yesdate;
  var yesterdayDateTime =
    yesyear +
    "-" +
    yesmonth +
    "-" +
    yesdate +
    " " +
    yeshour +
    ":" +
    yesminu +
    ":" +
    yessec;
  // 保存到变量
  context.currentDateTime = currentDateTime; // 当前时间年月日时分秒
  context.yesterdayDateTime = yesterdayDateTime; // 24小时前的年月日时分秒
  context.sttm = yestime;
  context.warmsttm = yestime;
  // this.hissttm = yestime;
  context.edtm = time;
  context.newtm = time;
  context.warmedtm = time;
}

/**
 * 更改项目
 */
export function changeitem(context, data, alertLevel) {
  let key = '';
  for (let i = 0; i < context.riskAll.length; i++) {
    if (context.riskAll[i].riskName === data) {
      key = i;
    }
  }
  context.itemType = data;
  context.gettitleList(alertLevel, context.riskAll[key].alertMessage);
}
